// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import BANK_CODES from '../../enums/BankCodes';

/**
 * @param root0
 * @param root0.bankCode
 * @param root0.label
 * @param root0.namespace
 * @returns {JSX} RenderBankCode
 */
function RenderBankCode({ bankCode, label = undefined, namespace = undefined }) {
    // Constants
    const bankCodeItemFound = BANK_CODES.find(bankCodeItem => bankCodeItem.bankCode === bankCode) ?? { bankCode: bankCode };

    return (
        <div className='flex flex-col items-center'>
            <div>
                {
                    label && namespace ?
                        <Entity entity={label} namespace={namespace} data={{ bankCode: bankCodeItemFound.bankCode }} />
                        : bankCodeItemFound.bankCode
                }
            </div>
            {bankCodeItemFound.bankLabel ?
                <div className='flex'>
                    <small title={bankCodeItemFound.bankLabel}
                        className='text-center'>
                        {bankCodeItemFound.bankLabel}
                    </small>
                </div>
                : false
            }
        </div>
    );
}

RenderBankCode.propTypes = {
    bankCode: PropTypes.string,
    label: PropTypes.string,
    namespace: PropTypes.string
};

export default RenderBankCode;